import { selectAllLiquidityRecurringCashflowItems } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySelectAllMutation } from './use-liquidity-select-all-mutation';

export const useSelectAllLiquidityRecurringCashflowItems = () =>
    useLiquiditySelectAllMutation({
        mutationFn: (clientId, selected) => selectAllLiquidityRecurringCashflowItems({ query: { clientId, selected } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityRecurringCashflowSettings,
    });
